"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var makeFooterCounterWithWord = function (word, wordMany) { return function (_a) {
    var value = _a.value;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [value, " ", (0, end2end_1.pluralize)(value, word, wordMany)] }));
}; };
exports.default = makeFooterCounterWithWord;
